/**
 * DataSource Adapter System
 *
 * Architettura per integrare datasource esterni (API patrimonio culturale, etc.)
 * con adapter client-specific che normalizzano i dati a formati comuni.
 *
 * Flusso:
 *   Customer Profile → DataSource Config → Adapter → Normalized Response
 */
// =============================================================================
// OPERATIONS
// =============================================================================
/**
 * Fonte unica delle operazioni abilitabili su un datasource
 * (`enabledOperations`). Usata da Zod (shared), enum Mongoose (builder-backend)
 * e checkbox del Builder: non ridefinire l'elenco altrove.
 */
export const DATASOURCE_OPERATIONS = [
    "suggest",
    "search",
    "detail",
    "list",
    "features",
    "related",
    "explain",
];
//# sourceMappingURL=datasource-adapter.js.map